import NAV_DATA from './route_mapping.js';
import LEFT_NAV_PERMISSION from '@/config/left_nav/index.js';
import TOP_NAV_PERMISSION from '@/config/top_nav/permission.js';
import TOP_COMMON_NAV from '@/config/top_nav/index.js';
import USER_NAV from '@/config/user_nav/index.js';

let _host = '';
if (process.env.NODE_ENV !== 'production') {
    _host = window.location.protocol + '//' + window.location.hostname + ':8888';
} else {
    _host = window.location.hostname.indexOf('top.yidianzixun.com') === -1 ? window.location.protocol + '//' + window.location.hostname + ':8888' : window.location.protocol + '//' + window.location.hostname;
}
const CONFIG = {
    ISDEV: process.env.NODE_ENV !== 'production',
    HOST: _host,
    NAV_DATA: NAV_DATA,
    LEFT_NAV_PERMISSION: LEFT_NAV_PERMISSION,
    TOP_NAV_PERMISSION: TOP_NAV_PERMISSION,
    TOP_COMMON_NAV: TOP_COMMON_NAV,
    USER_NAV: USER_NAV
};
export default CONFIG;


// WEBPACK FOOTER //
// ./src/config/index.js